import { AlertDismissExplanation } from './alert-dismiss-explanation';
import { AlertSummaryModel } from './alert-summary-model';

export class ProtectionAlertSummaryModel extends AlertSummaryModel {
  dismissExplanation: AlertDismissExplanation|null;
  providerId: string|null;
  providerTypeId: string|null;
  providerInstanceId: string|null;
}
